import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import { connect, useDispatch, useSelector } from "react-redux"
import ReactDrawer from "react-drawer"
import "react-drawer/lib/react-drawer.css"
import { Link, useHistory, useLocation } from "react-router-dom"

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import RightSidebar from "../CommonForBoth/RightSidebar"
import { getRoleLabel, useRole, ROLE_TYPES } from "../../hooks/useRole"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  showSidebarSm,
} from "../../store/actions"
import { LocalLogo } from "assets/images"
import Profile from "./Profile"

const Header = props => {
  const [search, setSearch] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const [isOpen, setIsOpen] = useState(false)

  const { profileDetails } = useSelector(state => ({
    profileDetails: state.Profile.profile,
  }))

  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)

  const { currentRole } = useRole()
  const [username, setUsername] = useState(currentRole)

  const settings = []

  useEffect(() => {
    setUsername(currentRole)
  }, [currentRole])

  const onDrawerClose = () => {
    setOpen(false)
  }

  const [sidebarSm, setSidebarSm] = useState(false)
  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
    setSidebarSm(!sidebarSm)
  }

  useEffect(() => {
    dispatch(showSidebarSm(sidebarSm))
  }, [dispatch, sidebarSm])

  const onCloseClick = () => {
    setIsOpen(false)

    history.push({
      pathname: location.pathname,
      search: "",
    })
  }

  const onClick = () => {
    setIsOpen(true)
  }

  useEffect(() => {
    if (location?.search === "?profile") {
      setIsOpen(true)
    }
  }, [location?.search])

  return (
    <React.Fragment>
      <Profile
        show={isOpen}
        onCloseClick={onCloseClick}
        state={isOpen}
        setState={setIsOpen}
      />

      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img
                    src={settings?.company?.logo[0]?.url ?? LocalLogo}
                    alt=""
                    height="35"
                  />
                </span>
              </Link>
              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src={settings?.company?.logo[0]?.url ?? LocalLogo}
                    alt=""
                    height="22"
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setSearch(!search)
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {profileDetails?.name ? (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => onClick()}
                  disabled={open}
                  className="d-flex align-items-center justify-content-end mt-0 mx-2"
                >
                  <span style={{ textTransform: "capitalize" }}>
                    {profileDetails?.role === ROLE_TYPES.ADMIN
                      ? `${profileDetails?.branch?.branch_admin?.name || profileDetails?.name} - ${profileDetails?.branch?.branch_name || ""}`
                      : profileDetails?.name}
                    <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
                  </span>
                </div>
              ) : (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => onClick()}
                  disabled={open}
                  className="d-flex align-items-center justify-content-end mt-0 mx-2"
                >
                  <span style={{ textTransform: "capitalize" }}>
                    {username}
                    <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
                  </span>
                </div>
              )}
              {getRoleLabel(profileDetails?.memberRole)}
            </div>

            <ProfileMenu />
          </div>
        </div>
      </header>
      <ReactDrawer open={false} position={position} onClose={onDrawerClose}>
        <RightSidebar onClose={onDrawerClose} />
      </ReactDrawer>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(Header)
